import React, { Component } from 'react';
import TabOfDataTable from '../../Elements/DataTable/TabOfDataTable';
import TpAdminItem from '../../Domain/TpAdminItem';
import TpAdminService from '../../Services/TpAdminService';
import TpAdminSearchParams from '../ThirdParty/TpAdmin/TpAdminSearchParams';

class ThirdPartySystemsAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const newSearchItem = new TpAdminSearchParams(props.UserId);

    this.state = {
      searchItem: newSearchItem,
    };
  }

  handleClickOnStartSearch(searchItem) {
    searchItem.UserId = this.props.UserId;
    return this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpAdminItem}
          serviceFunction={TpAdminService.GetTpAdminItemList}
          convertDBItemsFunction={TpAdminService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={TpAdminSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.handleClickOnStartSearch(searchItem)}
          singleSearchLine={true}
          isExportExcelDisabled={true}
          singleSearchLinePlaceholder='Search in IDs, name, email, source...'
          errorCode='TPSA38'
          enableUrlPush={false}
          useClickOnClearAll={true}
        />
      </div>
    );
  }
}

export default ThirdPartySystemsAdmin;
